module.exports = __webpack_public_path__ + "img/placeholder.514d6c75.png";